import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Widget, ViewWidget } from "bwtk";
import Store from "./Store";
import App from "./Views";
import { ContextProvider } from "./Context";
import { Config } from "./Utils/Config";
import { Pipe } from "./Utils/Pipe";

@Widget({ namespace: "AccessibilityFeedback" })
export default class extends ViewWidget {
  constructor(
    private store: Store,
    private config: Config,
    private pipe: Pipe
  ) {
    super();
  }

  init() {
    if (this.config.isDebugMode) {
      console.log("feedback widget initialized :", this.config);
    }
    this.pipe.subscribe(Pipe.Subscriptions(this.store));
  }

  destroy() {
    this.store.destroy();
  }

  render(root: Element) {
    const {
      store
    } = this;

    ReactDOM.render(
        <ContextProvider
          value={
            {
              config: this.config
            } as any
          }
        >
          <Provider {...{ store }}>
            {/* Store global provides */}
            <App />
          </Provider>
        </ContextProvider>,
      root
    );
  }
}